jQuery(document).ready(function onForceSignMessagesReady($) {
    "use strict";

    var $body = $('body');

    var $backdrop = $('<div class="dialog-backdrop dialog-backdrop--start-hidden" />');
    var $dialog;

    var index = 0;

    $body.append( $backdrop );

    init();

    setTimeout(function() {
        $backdrop.fadeIn('fast');
    }, 500);

    function init() {
        $dialog = createDialog(
            kulturnavigatorn_forced_messages.items[index].title,
            kulturnavigatorn_forced_messages.items[index].content
        );

        $dialog.find('button').on('click', submit);

        $backdrop.append($dialog);
    }

    function submit() {
        $.ajax({
            url: kulturnavigatorn_forced_messages.url,
            method: 'post',
            xhrFields: {
                withCredentials: true
            },
            data: {
                action: kulturnavigatorn_forced_messages.action,
                _wpnonce: kulturnavigatorn_forced_messages.items[index].nonce,
                post_id: kulturnavigatorn_forced_messages.items[index].id
            }
        }).success(function() {
            $dialog.remove();
            next();
        });
    }

    function next() {
        if ( ++index > kulturnavigatorn_forced_messages.items.length - 1) {
            document.location.reload();
        } else {
            $dialog = createDialog(
                kulturnavigatorn_forced_messages.items[index].title,
                kulturnavigatorn_forced_messages.items[index].content
            );

            $dialog.find('button').on('click', submit);

            $backdrop.append($dialog);
        }
    }

    function createDialog(title, content) {
        var dialog =
            '<div class="dialog dialog--fullscreen force-sign-dialog">' +
            '   <h2>%title%</h2>' +
            '   <div class="force-sign-dialog__content">' +
            '       %content%' +
            '   </div>' +
            '   <div class="force-sign-dialog__actions">' +
            '       <button class="button button--black">Signera</button>' +
            '   </div>' +
            '</div>';

        dialog = dialog
            .replace('%title%', title)
            .replace('%content%', content);

        return $(dialog);
    }
});